import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './Auth.css';

function PasswordInput({ 
  label, 
  placeholder, 
  value, 
  onChange, 
  error, 
  required = false,
  name,
  showStrength = false,
  strength = null
}) {
  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => setShowPassword(!showPassword);

  const getStrengthColor = () => {
    if (strength === 'strong') return 'strength-strong';
    if (strength === 'weak') return 'strength-weak';
    return '';
  };

  return (
    <div className="input-group">
      <label className="input-label">
        {label}{required && <span className="required">*</span>}
        {showStrength && strength && (
          <span className={`strength-indicator ${getStrengthColor()}`}>
            {strength === 'strong' ? 'Strong password' : 'Weak Password'}
          </span>
        )}
      </label>
      <div className="password-wrapper">
        <input
          type={showPassword ? 'text' : 'password'}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className={`input-field ${error ? 'input-error' : ''}`}
        />
        <button 
          type="button" 
          className="password-toggle" 
          onClick={togglePassword}
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>
      {error && <span className="error-message">{error}</span>}
    </div>
  );
}

export default PasswordInput;
